import { Brand, type MenuItemProps } from "@ir/ui";
import type { OrganizationsBrandsLookupItem } from "@src/domain/dto/organizationsBrands";

export function buildOrgBrandMenuItems(
  organizations: OrganizationsBrandsLookupItem[],
): MenuItemProps[] {
  return organizations.map((organization) => {
    const orgLabel =
      organization.organizationDisplayName ?? organization.organizationName;

    return {
      key: organization.organizationKey,
      label: orgLabel,
      icon: (
        <Brand
          size="small"
          variant="compact"
          brandName={orgLabel}
          logoSrcCompact={organization.organizationLogoUrl?.trim() || undefined}
        />
      ),
      children: (organization.brands ?? []).map((brand) => {
        const brandLabel = brand.brandDisplayName ?? brand.brandName;
        return {
          key: brand.brandKey,
          label: brandLabel,
          icon: (
            <Brand
              size="small"
              variant="compact"
              brandName={brandLabel}
              logoSrcCompact={brand.brandLogoUrl?.trim() || undefined}
            />
          ),
        };
      }),
    };
  });
}
